<template>
  <div :class="['load-screen', { loaded }]">
    <div :class="['outer-bar', { loaded: gameLoaded }]" ref="outerBar">
      <div class="inner-bar" ref="innerBar"></div>
    </div>
    <img :class="['splash', { loaded: gameLoaded }]" :src="splashUrl" ref="splashImg"/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gameLoaded: false,
      splashFinished: false,
      splashUrl: '',
      currentSplashIndex: null,
    }
  },
  props: ['splashStack', 'loadingRatio'],
  computed: {
    loaded() {
      return (this.gameLoaded && this.splashFinished)
    }
  },
  watch: {
    loadingRatio (newValue, oldValue) {
      if (this.loadingRatio >= 100) {
        this.gameLoaded = true
      }
      this.$refs.innerBar.style.width = `${Math.floor(this.loadingRatio)}%`
    },
    currentSplashIndex (newValue, oldValue) {
      if (newValue >= this.splashStack.length){
        //this.splashFinished = true
        return
      }
      let style = this.splashStack[newValue]

      this.$refs.innerBar.style['background'] = style.innerBarColor
      this.$refs.outerBar.style['background'] = style.outerBarColor
      this.$refs.splashImg.style['opacity'] = 1
      this.splashUrl = style.splashUrl

      let displayTime = (newValue > 0 ? style.duration + 500 : style.duration)
      setTimeout(this.fadeToNextSplash, displayTime)
    }
  },
  mounted() {
    this.currentSplashIndex = 0
  },
  methods: {
    fadeToNextSplash() {
      if (this.currentSplashIndex < this.splashStack.length -1){
        this.$refs.splashImg.style['opacity'] = 0
        setTimeout(() => this.currentSplashIndex += 1, 1000)
      }
      else {
        this.splashFinished = true
      } 

    },
  }
}
</script>

<style scoped>
.outer-bar {
  position: absolute;
  left: 8%;
  right: 8%;
  bottom: 100px;
  width: auto;
  height: 30px;
  border-radius: 20px;
  padding: 4px;
  background: white;
  opacity: 1;
  transition: background 1s, opacity 1.5s;
  transition-delay: 0.2s, 0s;
  z-index: 10;
}
.inner-bar {
  border-radius: inherit;
  transition: inherit;
  transition-delay: inherit;
  height: 100%;
}

.splash{
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 1s;
}
.load-screen {
  transition: opacity 1s;
  transition-delay: 1s;
  opacity: 1;
  background: black;
}
.loaded {
  pointer-events: none;
  opacity: 0;
}
</style>
